import {
  AvgTimeToDeliverByCarrierResponseSchema,
  OMSMetricsRequestSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getAvgTimeToDeliverByCarrier = {
  name: "getAvgTimeToDeliverByCarrier" as const,
  input: OMSMetricsRequestSchema,
  output: AvgTimeToDeliverByCarrierResponseSchema,
};
